export default __webpack_public_path__ + "static/media/u-said-it-v13-1167.949cee7e.mp3";